import { render, staticRenderFns } from "./SelectSimpleComponent.vue?vue&type=template&id=16dc647d"
import script from "./SelectSimpleComponent.vue?vue&type=script&lang=js"
export * from "./SelectSimpleComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectSimpleComponent.vue?vue&type=style&index=0&id=16dc647d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports